"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useT } from "@/components/i18n-ui/provider";
import { MARKETING_NAV } from "./nav";

export function DesktopNav() {
  const t = useT("marketing");
  const pathname = usePathname();
  return (
    <nav aria-label={t("nav.main")} className="hidden lg:block">
      <ul className="flex items-center gap-1">
        {MARKETING_NAV.map((n) => {
          const active = pathname === n.href;
          return (
            <li key={n.href}>
              <Link href={n.href} aria-current={active ? "page" : undefined} className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${active ? "bg-ink-100 text-ink-950" : "text-ink-600 hover:text-ink-950"}`}>
                {t(n.label)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
